//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import React, { useEffect, useState } from "react";
import styles from "../assets/styles/Dropdown.module.css";
import table_dropDown_icon from "../assets/images/table_dropDown_icon.png";
import { useNavigate } from "react-router";
import { BASE_URL } from "./baseURL";
import Request from "axios";
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

const DeleteDropdown = ({ setMask, mask, data, type, getData }) => {
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//
  const navigation = useNavigate();
  const [show, setShow] = useState(false);
  let temp = JSON.parse(localStorage.getItem("user"));
  const options =
    temp?.Role === "Admin"
      ? ["Delete"]
      : [
          "Program",
          "View Assessment",
          "Create Meal Plan",
          "Client Progress",
          "Print Meal Plan",
          "Blood History",
          "Period History",
        ];
  const [selectedItem, setSelectedItem] = useState();
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//

  //---------------------------------------------------------UseEffect to set Show-----------------------------------------------------------------------//

  useEffect(() => {
    !mask && setShow(false);
  }, [mask]);

  //---------------------------------------------------------UseEffect to set Show-----------------------------------------------------------------------//

  //---------------------------------------------------------On Item Click Function-----------------------------------------------------------------------//

  function onItemClick(val) {
    if (val === "Delete") {
      //   navigation("/viewclient", { state: { data: data } });
      if (type == "weight") {
        Request.post(`${BASE_URL}tracker/deleteweighttracker`, {
          id: data?.id,
        })
          .then((res) => {
            //   console.log("Res?.data", res?.data);
            getData();
          })
          .catch((err) => {
            console.log("Error deleting weight", err);
            alert("Error deleting weight!");
          });
      } else {
        Request.post(`${BASE_URL}tracker/deleteinchtracker`, {
          id: data?.id,
        })
          .then((res) => {
            //   console.log("Res?.data", res?.data);
            getData();
          })
          .catch((err) => {
            console.log("Error deleting inch", err);
            alert("Error deleting inch!");
          });
      }
    }
  }

  //---------------------------------------------------------On Item Click Function-----------------------------------------------------------------------//

  return (
    <div className="" style={{ width: "100%", position: "relative" }}>
      <a
        role="button"
        onClick={() => {
          setShow(true);
          setMask(true);
        }}
      >
        <img src={table_dropDown_icon} />
      </a>
      {show && (
        <div className={styles["dropCont"]} onBlur={() => setShow(false)}>
          {options?.map((val, i) => {
            return (
              <a
                key={String(i)}
                onClick={() => {
                  onItemClick(val);
                  setShow(false);
                  setMask(false);
                }}
                className={styles["items"]}
                style={{
                  backgroundColor:
                    val === selectedItem ? "#E6F8F1" : "transparent",
                }}
              >
                {val}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DeleteDropdown;
